import React from 'react'

import "./tiles.css"
export default function DashCard(props) {
    return (
        <div className="card card-none-border">
            <div className="card-body card-bd">
                <div className='d-flex justify-content-between'>
                    <div>
                        <div className='dsah-title'>{props.title}</div>
                        <div className='my-2 float-left dash-cont'>{props.count}</div>
                    </div>
                    <div className='my-auto'>
                        <div className='dash-cntainer'>
                            <img className={`${props.title=="Total On Hold"?"dash-img-section-hold":props.title=="Total Canceled"?"img-section":props.title=="Total Completed"?"img-section":"dash-img-section"} my-2` } src={props.icon} width={50} height={48} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
